import type { ReactElement, ReactNode } from 'react';
import { cloneElement } from 'react';

import type { TBenefitsWithTimer, TBenefitsDefaultMobile } from '../models';

export const renderButtons = (
    buttons: ReactNode | ReactNode[],
    { sendEvent, analytics, onEventPublish = () => {} }: TBenefitsWithTimer | TBenefitsDefaultMobile
) => {
    const handlerClick = () => {
        sendEvent(analytics);
        onEventPublish();
    };

    if (Array.isArray(buttons)) {
        return buttons.map(button =>
            cloneElement(button as ReactElement, { onClick: handlerClick })
        );
    } else {
        return cloneElement(buttons as ReactElement, { onClick: handlerClick });
    }
};
